import { useState, useMemo } from 'react';

import copy from "fast-copy";
import { original, current, produce } from "immer";

export class ContextActions {
    /*constructor(reactSetState) {
        this.setState = (fn, taskName) => {
            reactSetState((prevState) => {
                let prevNextStateClone = copy(prevState);
                fn(prevNextStateClone);
                console.log(taskName, prevState, prevNextStateClone);
                return prevNextStateClone;
            });
        };
    }*/

    constructor(reactSetState) {
        this.setState = (fn, taskName) => {
            reactSetState(
                produce((draft) => {
                    fn(draft)
                    console.log(taskName, original(draft), current(draft))
                })
            );
        };
    }
}

export function createContextProvider(Context, initialState, ActionsClass) {
    return (props) => {
        const [state, setState] = useState(initialState);

        let actions = useMemo(() => {
            return new ActionsClass(setState);
        }, [setState]);

        return (
            <Context.Provider value={[state, actions]}>
                {props.children}
            </Context.Provider >
        );
    }
}